<script setup lang="ts">
const toasts = useToastsStore()

const toneClasses = {
  success: 'border-emerald-400/30 bg-emerald-950/95 text-emerald-100 shadow-emerald-950/30',
  info: 'border-border bg-panel-2/95 text-muted shadow-black/40',
  warn: 'border-accent-dim/50 bg-[#2a1b10]/95 text-accent shadow-black/40',
  error: 'border-red-400/35 bg-red-950/95 text-red-100 shadow-red-950/30',
}
</script>

<template>
  <Teleport to="body">
    <div
      v-if="toasts.messages.length"
      class="pointer-events-none fixed bottom-4 right-4 z-[90] flex w-[min(380px,calc(100vw-2rem))] flex-col gap-2 max-[640px]:bottom-3 max-[640px]:left-3 max-[640px]:right-3 max-[640px]:w-auto"
      aria-live="polite"
      aria-atomic="false"
    >
      <TransitionGroup name="toast">
        <div
          v-for="toast in toasts.messages"
          :key="toast.id"
          role="status"
          class="pointer-events-auto rounded border px-3 py-2.5 text-xs shadow-2xl backdrop-blur"
          :class="toneClasses[toast.tone]"
        >
          <div class="flex items-start justify-between gap-3">
            <span class="min-w-0 flex-1 leading-snug">{{ toast.message }}</span>
            <div class="flex shrink-0 items-center gap-2">
              <button
                v-if="toast.action"
                type="button"
                class="rounded border border-border bg-panel px-2 py-0.5 text-[12px] uppercase tracking-wide text-ink hover:border-accent-dim"
                @click="toasts.runAction(toast.id)"
              >
                {{ toast.action.label }}
              </button>
              <button
                type="button"
                class="text-muted-dim hover:text-ink"
                title="Dismiss"
                aria-label="Dismiss notification"
                @click="toasts.dismiss(toast.id)"
              >
                x
              </button>
            </div>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: opacity 160ms ease, transform 160ms ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
